// eslint-disable-next-line import/prefer-default-export
export const USUARIOS_URL = 'https://api.hdsa.gov.co/users';
// eslint-disable-next-line import/prefer-default-export
// export const USUARIOS_URL = 'http://localhost:4000/users';
